import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EPFHistory } from 'src/model/epf.model';
import { EpfService } from 'src/services/epf.service';

@Component({
    selector: 'app-view-epf-change-history',
    templateUrl: './view-epf-change-history.component.html',
    styleUrls: ['./view-epf-change-history.component.scss'],
    standalone: false
})
export class ViewEpfChangeHistoryComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private epfService = inject(EpfService);

  @Input() customerId: number;
  historyList: EPFHistory[] = [];

  ngOnInit(): void {
    this.getCustomerEPFHistory();
  }

  async getCustomerEPFHistory() {
    this.historyList = await this.epfService.getCustomerEPFChangeHistory(this.customerId);
  }

  reset() {
    this.activeModal.close();
  }
}
